import { z } from 'zod';
import { QUESTION_TYPES } from '../../constants';
import { formOptionSchema } from './form-option';

export const formQuestionSchema = z.object({
  id: z.number().int().positive().optional(),
  question: z.string().min(1).max(255),
  instructions: z.string().max(255).nullable().optional(),
  type: z.enum(QUESTION_TYPES),
  locale: z.record(z.string(), z.string()).optional(),
  claim_section_id: z.number().int().positive().nullable(),
  order: z.number().int(),
  form_options: z.array(formOptionSchema).optional(),
});
export type FormQuestionInput = z.infer<typeof formQuestionSchema>;
